import React from 'react';

import styled, { DefaultTheme, css } from 'styled-components';

import { LocalizedString } from 'utils/localize';

import { AlignText, ThemeColors } from 'types';

export type HeadingLevel = 'h2' | 'h3';

export interface StyleProps {
  marginTop?: number;
  marginBottom?: number;
  size?: number;
  color?: ThemeColors;
  align?: AlignText;
}

export interface HeadingProps extends StyleProps {
  level: HeadingLevel;
  children?: LocalizedString;
}

function Heading({ level, children, ...props }: HeadingProps) {
  switch (level) {
    case 'h3':
      return <H3 {...props}>{children}</H3>;

    case 'h2':
    default:
      return <H2 {...props}>{children}</H2>;
  }
}

export default Heading;

const sharedStyles = (theme: DefaultTheme) => css`
  ${({
    marginTop = 0.5,
    marginBottom = 0.5,
    color = 'mirage',
    size = 1.45,
    align = 'inherit',
  }: StyleProps) => css`
    margin-top: ${marginTop}em;
    margin-bottom: ${marginBottom}em;
    color: ${theme.colors[color]};
    font-size: ${size}em;
    text-align: ${align};
  `}
`;

const H2 = styled.h2`
  ${({ theme }) => sharedStyles(theme)};
`;

const H3 = styled.h3`
  ${({ theme }) => sharedStyles(theme)};
`;
